<template>
  <v-btn
    color="secondary"
    rounded
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </v-btn>
</template>

<script>
  export default {
    name: 'BaseBtn1',
  }
</script>



// WEBPACK FOOTER //
// src/components/base/Btn1.vue